import { Box, styled } from '@mui/material';
import { Link } from '~/components/link';

export const PlaylistCardContainer = styled(Box)(() => ({ display: 'flex' }));

export const PlaylistCardChildren = styled(Box)(() => ({ alignItems: 'center', display: 'flex' }));

export const PlaylistCardLink = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  minWidth: 0,
  padding: theme.spacing(1, 0),
  textDecoration: 'none',
}));

export const PlaylistCardNotLink = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  minWidth: 0,
  padding: theme.spacing(1, 0),
}));

export const PlaylistCardIconContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  padding: theme.spacing(1),
  width: '50px',
}));

export const PlaylistCardMetaContainer = styled(Box)(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
}));
